import { JSONEditor } from '@json-editor/json-editor'

class Header extends JSONEditor.AbstractEditor {
  build () {
    this.active = false
    this.header = document.createElement('span')
    this.header.textContent = this.getTitle()
    this.title = this.theme.getHeader(this.header)
    this.container.appendChild(this.title)

    if (this.schema.description) {
      this.description = this.theme.getDescription(this.translateProperty(this.schema.description))
      this.container.appendChild(this.description)
    }
  }
}

export default Header
